import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Spinner } from "reactstrap";
import { getVenueById, updateVenueById } from "../../../../api";

const validationSchema = Yup.object({
  basePrice: Yup.number().required("Base price is required"),
  perHour: Yup.number().required("Per hour is required"),
  deposit: Yup.number().required("Deposit is required"),
  contractText: Yup.string().required("Contract details required"),
});

const OtherDetailsTab = ({ venueData, venueId ,refreshVenue }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [serviceName, setServiceName] = useState("");
  const [servicePrice, setServicePrice] = useState("");
  const [services, setServices] = useState<{ name: string; price: string }[]>(
    []
  );

  const [amenityInput, setAmenityInput] = useState("");
  const [amenities, setAmenities] = useState<string[]>([]);  
  const [error, setError] = useState<string | null>(null);
  const [initialValues, setInitialValues] = useState({
    basePrice: "",
    perHour: "",
    deposit: "",
    contractText: "",
  });
  
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema,
      onSubmit: async (values) => {
  if (isLoading) return;

  if (!venueId) {
    toast.error("Venue not loaded yet");
    return;
  }

  try {
    setIsLoading(true);

    const payload = {
      basePrice: Number(values.basePrice),
      perHour: Number(values.perHour),
      deposit: Number(values.deposit),
      contractText: values.contractText,
      services,
      amenities,
    };

    await updateVenueById(venueId, payload);
    toast.success("Other details saved");
    await refreshVenue();
  } catch (err) {
    console.error(err);
    toast.error("Update failed");
  } finally {
    setIsLoading(false);
}

    }
  });

  const addService = () => {
    if (!serviceName || !servicePrice) return;
    setServices([...services, { name: serviceName, price: servicePrice }]);
    setServiceName("");
    setServicePrice("");
  };

  const removeService = (index: number) => {
    setServices(services.filter((_, i) => i !== index));
  };

  const addAmenity = () => {
    if (!amenityInput.trim()) return;
    setAmenities([...amenities, amenityInput.trim()]);
    setAmenityInput("");
  };

  const removeAmenity = (index: number) => {
    setAmenities(amenities.filter((_, i) => i !== index));
  };
  useEffect(() => {
    if (!venueData) return;
    setInitialValues({
      basePrice: venueData?.base_price ?? "",
      perHour: venueData?.per_hour ?? "",
      deposit: venueData?.deposit ?? "",
      contractText: venueData?.contract_text ?? "",
    });

    setServices(venueData?.services ?? []);
    setAmenities(venueData?.amenities ?? []);
  }, [venueData, venueId]);


  return (
    <div className="tab-from-content">
      <ToastContainer autoClose={2000} />
      <div className="venue-tab-card main-card">
        <h4 className="venue-tab-title">
          <i className="fa-solid fa-list-check" />
          Additional Details
        </h4>
        <div className="venue-tab-body">
          <form onSubmit={formik.handleSubmit}>
            <div className="venue-form-section form-group">
              <label className="form-label">Base Price</label>
              <input
                type="text"
                className="form-control h_44"
                name="basePrice"
                value={formik.values.basePrice}
                onChange={formik.handleChange}
              />
            </div>

            <div className="venue-form-section row">
              <div className="col-md-6">
                <label className="form-label">Per Hour</label>
                <input
                  type="text"
                  className="form-control h_44"
                  name="perHour"
                  value={formik.values.perHour}
                  onChange={formik.handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Deposit</label>
                <input
                  type="text"
                  className="form-control h_44"
                  name="deposit"
                  value={formik.values.deposit}
                  onChange={formik.handleChange}
                />
              </div>
            </div>

            <div className="venue-form-section form-group">
              <label className="form-label">Additional Services</label>
              <div className="row g-2 mb-2">
                <div className="col-md-6">
                  <input
                    className="form-control h_44"
                    placeholder="Service name"
                    value={serviceName}
                    onChange={(e) => setServiceName(e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control h_44"
                    placeholder="Price"
                    value={servicePrice}
                    onChange={(e) => setServicePrice(e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn btn-default btn-hover steps_btn h_44 w-100"
                    onClick={addService}
                  >
                    <i className="fa-solid fa-plus" />
                  </button>
                </div>
              </div>
              <div className="row g-2 mt-2">
                {services.map((s, i) => (
                  <div key={i} className="col-lg-4 col-md-4 col-sm-6">
                    <div className="venue-chip">
                      <span>{s.name} · NZ$ {Number(s.price).toLocaleString("en-NZ")}</span>
                      <i
                        className="fa-solid fa-xmark venue-chip-remove"
                        onClick={() => removeService(i)}
                        aria-label="Remove service"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="venue-form-section form-group">
              <label className="form-label">Contract & Booking</label>
              <textarea
                rows={4}
                className="form-control"
                name="contractText"
                value={formik.values.contractText}
                onChange={formik.handleChange}
              />
            </div>

            <div className="venue-form-section form-group">
              <label className="form-label">Amenities</label>
              <div className="d-flex gap-2 mb-2">
                <input
                  className="form-control h_44"
                  placeholder="Enter amenity"
                  value={amenityInput}
                  onChange={(e) => setAmenityInput(e.target.value)}
                />
                <button
                  type="button"
                  className="btn btn-default btn-hover steps_btn h_44"
                  style={{ minWidth: "88px" }}
                  onClick={addAmenity}
                >
                  <i className="fa-solid fa-plus" />
                </button>
              </div>
              <div className="row g-2">
                {amenities.map((a, i) => (
                  <div key={i} className="col-lg-4 col-md-4 col-sm-6">
                    <div className="venue-chip">
                      <span>{a}</span>
                      <i
                        className="fa-solid fa-xmark venue-chip-remove"
                        onClick={() => removeAmenity(i)}
                        aria-label="Remove amenity"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="venue-tab-actions">
              <button
                className="btn btn-default btn-hover steps_btn h_44"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? <Spinner size="sm" color="white" /> : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default OtherDetailsTab
